import {JSONable} from "@irian-ro/abstract-resource";

export class DelLegalEntityVO extends JSONable {

  uuid: string | undefined = undefined;
  companyName: string | undefined = undefined;
  industryType: string | undefined = undefined;
  country: string | undefined = undefined;
  uniqueIdentificationNumber: string | undefined = undefined;
  hasContacts: boolean | undefined = undefined; //frontend only
  name: string | undefined = undefined;
}
